import { App } from '../features/home';
import PageNotFound from '../features/common/PageNotFound';
import homeRoute from '../features/home/route';
import commonRoute from '../features/common/route';
import { gestionCuentas, gestionDatos, maestroDatos } from 'car-data-master/route';
import carDataCatalogoRoute from '../features/car-data-catalogo/route';
import dashboardRoute from '../features/dashboard/route'
import stockRoute from '../features/stock/route';
import catalogo from '../features/vista-vendedor/route';
import simuladorFinancieroRoute from '../features/simulador-financiero/route';
import comparador from '../features/comparador/route';
import peritadorRoute from '../features/peritador/route';
import presupuestadorRoute from '../features/presupuestador/route';
import cotizadorRoute from '../features/cotizador/route';
import solicitudVentaRoute from '../features/solicitud-venta/route';
import gestionOperativaRoute from '../features/gestion-operativa/route';
import clientesRoute from '../features/clientes/route';
import precioJustoRoute from '../features/precio-justo/route';
import usuariosRoute from '../features/usuarios/route';
import perfilesRoute from '../features/perfiles/route';
import gastosGestoriaRoute from '../features/gastos-gestoria/route';
import compraUsadosRoute from '../features/compra-usados/route';
import commissionsRoute from '../features/commissions/route';
import policyCommercialRoute from '../features/price-policies/route';
import paymentsRoute from '../features/payments/route';
import integrationsRoute from '../features/integrations/route';
import leadsRoute from '../features/leads/route';
import savingsPlanRoute from '../features/savings_plan/route';
// NOTE: DO NOT CHANGE the 'childRoutes' name and the declaration pattern.
// This is used for Rekit cmds to register routes config for new features, and remove config when remove features, etc.
const childRoutes = [
  commonRoute,
  homeRoute,
  clientesRoute,
  carDataCatalogoRoute,
  dashboardRoute,
  stockRoute,
  compraUsadosRoute,
  catalogo,
  comparador,
  presupuestadorRoute,
  solicitudVentaRoute,
  gestionOperativaRoute,
  peritadorRoute,
  cotizadorRoute,
  paymentsRoute,
  policyCommercialRoute,
  commissionsRoute,
  simuladorFinancieroRoute,
  gastosGestoriaRoute,
  maestroDatos,
  gestionDatos,
  gestionCuentas,
  precioJustoRoute,
  usuariosRoute,
  perfilesRoute,
  integrationsRoute,
  leadsRoute,
  savingsPlanRoute,
];

const routes = [
  {
    path: '/',
    component: App,
    childRoutes: [
      ...childRoutes,
      { path: '*', name: 'Page not found', component: PageNotFound },
    ].filter(r => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  }
];

export default routes;
